export default __webpack_public_path__ + "static/394-aa2c316c16eb70b8ee595efd1185901e.gif";